"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Style = exports.CSS = void 0;
var input_checkbox_1 = require("../../components/input/input.checkbox");
var tag_icon_style_1 = require("../tag.icon/tag.icon.style");
exports.CSS = {
    container: 'c-TagCardCheckbox',
    hasSelections: 'c-TagCardCheckbox__has-selections'
};
exports.Style = (_a = {},
    _a[exports.CSS.container] = {
        display: 'flex',
        alignItems: 'center'
    },
    _a["".concat(exports.CSS.container, " .").concat(input_checkbox_1.CSS.container)] = {
        display: 'none',
        width: 'inherit',
        height: 'inherit'
    },
    _a["".concat(exports.CSS.container, ":hover .").concat(tag_icon_style_1.CSS.container)] = {
        display: 'none'
    },
    _a["".concat(exports.CSS.container, ":hover .").concat(input_checkbox_1.CSS.container)] = {
        display: 'flex'
    },
    _a["".concat(exports.CSS.container, ".").concat(exports.CSS.hasSelections, " .").concat(input_checkbox_1.CSS.container)] = {
        display: 'flex'
    },
    _a);
//# sourceMappingURL=tag.card.checkbox.style.js.map